import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Header from "../components/Header";
import Footer from '../components/Footer'

const ForCompany = () => (
    <div>
        <Header/>
        <div className="content partslist-page">
            <div className="container">
                <div className="pb-5">
                    <h1 className="title-partslist-page">サシイレをご覧の企業担当者様へ</h1>
                    <div className="img-three-dot">
                        <img src="/images/three-dot.png" className="img-fluid"/>
                    </div>
                    <div className="text-center my-3">
                        <img src="/images/img-omoiwo.jpg" alt="想いをカタチに"/>
                    </div>
                    <div>
                        この度はサシイレへご訪問頂きまして有り難うございます。<br/>
                        このサシイレは、日夜部活に励むアスリートを支援するために、OBやファンの方々が「想いをカタチ」に変えて応援する、”新しい応援のカタチ”を目指しています。<br/>
                        サシイレでは、選手達が練習や合宿生活において必要としている商品を、サシイレ可能商品として販売していますが、選手達がサシイレをして欲しいと望んでいる商品は掲載されているものに限りません。<br/>
                        <br/>
                        <br/>
                        そこで、当サイトで販売するに相応しい商品（選手達が練習や合宿生活において必要としている商品）を貴社でお取り扱いしていましたら、当サイトでも販売させて頂けませんでしょうか？<br/>
                        <br/>
                        サシイレでの商品販売にご興味を持たれましたら、お気軽に<Link to="/contact/company">お問い合わせ</Link>下さいませ。<br/>
                        <br/>
                        今後ともサシイレをよろしくお願い致します。
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
)

export default ForCompany